module.exports = __webpack_public_path__ + "images/category_lp/jewel/store_images/1_7db0927397aa987cc67c8afd62037d2c.png";